import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-reseau-de-soins',
  templateUrl: './reseau-de-soins.component.html',
  styleUrls: ['./reseau-de-soins.component.scss']
})
export class ReseauDeSoinsComponent implements OnInit {

  constructor() { }
  ngOnInit(): void {}
}
